﻿import { Component, OnInit, ViewChild } from "@angular/core";
import { Params, Router } from "@angular/router";
import { LocalStorageService } from "angular-2-local-storage";

// Import Model
import { UserModel, UserRoleListModel } from "../../../model/jubili/setting-user/user-data";
import { SettingService } from "../../../service/api/jubili/setting.service";
import { AuthenticationService } from "../../../service/api/auth/auth.service";

@Component({
    selector: "bo-jub-setting",
    styleUrls: ["./setting.component.scss"],
    templateUrl: "./setting.component.html"
})

export class SettingComponent implements OnInit {

    constructor(
        private router: Router,
        private localStorageService: LocalStorageService,
        private settingService: SettingService,
        private AuthService: AuthenticationService
    ) { }

    userModel: UserModel = new UserModel();
    userPermission: Array<UserRoleListModel> = new Array<UserRoleListModel>();
    email: string = "";

    ngOnInit(): void {
        this.setDataUserlist();
    }

    setDataUserlist(): void {
        this.settingService.getUserBackOffice()
        .subscribe(
            Response => {
                this.userModel = Response;
                this.userPermission = this.userModel.data;
            },
            err => {
                // unauthorized refresh token
                console.log("unauth");
                if (err.status === 401) {
                    this.AuthService.refreshSessionToken()
                    .subscribe(
                        Response => {
                            // Update session
                            this.localStorageService.set("accessToken", Response.authenticationResult.accessToken);

                            this.localStorageService.set("expiresTime", (Date.now() / 1000) + Response.authenticationResult.expiresIn);
                            this.setDataUserlist();
                        }
                    );
                } else {
                    this.router.navigate(["/home"]);
                }
            }
        );
    }

    deletePermission(userSurrKey: number): void {
        this.settingService.deletePermissionBackOffice(userSurrKey)
        .subscribe(
            Response => {
                this.setDataUserlist();
            },
            err => {
                // unauthorized refresh token
                console.log("unauth");
                if (err.status === 401) {
                    this.AuthService.refreshSessionToken()
                    .subscribe(
                        Response => {
                            // Update session
                            this.localStorageService.set("accessToken", Response.authenticationResult.accessToken);

                            this.localStorageService.set("expiresTime", (Date.now() / 1000) + Response.authenticationResult.expiresIn);
                            this.setDataUserlist();
                        }
                    );
                } else {
                    this.router.navigate(["/home"]);
                }
            }
        );
    }
}
